import axios from 'axios';
import { airshopUrl } from './AppConfig';

// Api
export const AirshopApi = axios.create();
AirshopApi.defaults.baseURL = airshopUrl();
AirshopApi.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
